module.exports = __webpack_public_path__ + "5f734d921b0b2e2fa02cc33367a1d33e.svg";